export default class YearFilterModel {
  static clampIndex(index: number, total: number, visible: number): number {
    const maxIndex = Math.max(0, total - visible);
    return Math.min(Math.max(0, index), maxIndex);
  }

  static computeFitCount(containerWidth: number, chipWidth: number, gap: number): number {
    if (containerWidth <= 0 || chipWidth <= 0) return Infinity;
    return Math.max(1, Math.floor((containerWidth + gap) / (chipWidth + gap)));
  }

  static ensureVisible(startIndex: number, anchorIndex: number, total: number, visible: number): number {
    if (anchorIndex < 0) return YearFilterModel.clampIndex(startIndex, total, visible);
    if (anchorIndex < startIndex) return YearFilterModel.clampIndex(anchorIndex, total, visible);
    if (anchorIndex > startIndex + visible - 1) {
      return YearFilterModel.clampIndex(anchorIndex - visible + 1, total, visible);
    }
    return YearFilterModel.clampIndex(startIndex, total, visible);
  }
}
